import React from 'react'
import Routes from './Routes'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const App = () => {
  return (
    <div className="app">
      <ToastContainer hideProgressBar />
      <Routes />
    </div>
  )
}

export default App
